import { render } from "./AppNavbar.vue?vue&type=template&id=47f3451e&ts=true"
import script from "./AppNavbar.vue?vue&type=script&lang=ts"
export * from "./AppNavbar.vue?vue&type=script&lang=ts"

import "./AppNavbar.vue?vue&type=style&index=0&id=47f3451e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__